//获取当前链接所包含的品牌，产业和型号
export default {
    getBIP (url) {
        let urlList=url.split('/');
        // 本地调试
        // let brand=urlList[3];
        // let industry=urlList[4];

        // 发布后
        let brand=urlList[4];
        let industry=urlList[5];

        let urlParamsList=url.split('?')[1].split('&');
        let urlParamsjson={};
        urlParamsList.forEach(element => {
            let name=element.split('=')[0]
            urlParamsjson[name]=element.split('=')[1];
        });
        let productCode=urlParamsjson.productCode;
        //app嵌入后缀拼接
        let appParams=url.split('?')[1]
        return {
            brand,industry,productCode,appParams
        }
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./utils/GetBIPtools.js
// module id = null
// module chunks = 